module.exports = __webpack_public_path__ + "img/rounded-bg.3f28e176.svg";